import React from "react";

function Shipped() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#b4e66e"
        d="M358.614 102.079H50.772a8.552 8.552 0 00-8.551 8.551v179.574h25.653c9.445 0 17.102 7.656 17.102 17.102 0 9.445-7.658 17.102-17.102 17.102H42.221v25.653a8.552 8.552 0 008.551 8.551h316.393V110.63a8.552 8.552 0 00-8.551-8.551z"
        data-original="#b4e66e"
      ></path>
      <path
        fill="#ffdc64"
        d="M469.779 238.898H367.165v119.716h136.818v-85.512c0-18.89-15.314-34.204-34.204-34.204z"
        data-original="#ffdc64"
      ></path>
      <path
        fill="#ffc850"
        d="M367.165 264.551h92.638c9.446 0 17.102 7.656 17.102 17.102v76.96h-109.74v-94.062z"
        data-original="#ffc850"
      ></path>
      <path
        fill="#ffdc64"
        d="M435.574 136.284h-68.409v34.205h94.063v-8.551c0-14.169-11.486-25.654-25.654-25.654z"
        data-original="#ffdc64"
      ></path>
      <path
        fill="#b4e6ff"
        d="M469.779 238.898l-17.103-68.409h-85.511v68.409z"
        data-original="#b4e6ff"
      ></path>
      <path
        fill="#f1f4fb"
        d="M469.779 273.102h34.205v34.205h-17.102c-9.446 0-17.102-7.656-17.102-17.102v-17.103z"
        data-original="#f1f4fb"
      ></path>
      <path
        fill="#e1a546"
        d="M427.023 298.756c-25.772 0-48.194 14.265-59.858 35.317v24.541h127.676c-4.217-33.737-32.939-59.858-67.818-59.858z"
        data-original="#e1a546"
      ></path>
      <path
        fill="#ffc850"
        d="M476.904 320.412v38.202h17.937c-1.836-14.689-8.323-27.928-17.937-38.202z"
        data-original="#ffc850"
      ></path>
      <circle
        cx="427.023"
        cy="367.165"
        r="42.756"
        fill="#5b5d6e"
        data-original="#5b5d6e"
      ></circle>
      <path
        fill="#9bd6ff"
        d="M401.37 196.142h57.72l-6.413-25.653h-85.511v68.409h25.653v-34.205a8.55 8.55 0 018.551-8.551z"
        data-original="#9bd6ff"
      ></path>
      <path
        fill="#a0d755"
        d="M144.835 298.756c-21.593 0-40.819 10.028-53.355 25.653H42.221v25.653a8.552 8.552 0 008.551 8.551h316.393v-34.205H198.19c-12.536-15.624-31.762-25.652-53.355-25.652z"
        data-original="#a0d755"
      ></path>
      <circle
        cx="144.835"
        cy="367.165"
        r="42.756"
        fill="#5b5d6e"
        data-original="#5b5d6e"
      ></circle>
      <path
        d="M476.158 231.363l-13.259-53.035c3.625-.77 6.345-3.986 6.345-7.839v-8.551c0-18.566-15.105-33.67-33.67-33.67h-60.392V110.63c0-9.136-7.432-16.568-16.568-16.568H50.772c-9.136 0-16.568 7.432-16.568 16.568V256a8.017 8.017 0 0016.034 0V110.63c0-.295.239-.534.534-.534h307.841c.295 0 .534.239.534.534v145.372a8.017 8.017 0 0016.034 0v-9.088h94.569l.021.002.022-.001c11.637.007 21.518 7.646 24.912 18.171h-24.928a8.017 8.017 0 00-8.017 8.017v17.102c0 13.851 11.268 25.119 25.119 25.119h9.086v35.273h-20.962c-6.886-19.882-25.787-34.205-47.982-34.205s-41.097 14.322-47.982 34.205h-3.86v-60.392a8.017 8.017 0 00-16.034 0v60.391H192.817c-6.886-19.883-25.787-34.205-47.982-34.205s-41.097 14.322-47.982 34.205H50.772a.534.534 0 01-.534-.534v-17.637h34.739a8.017 8.017 0 000-16.034H8.017a8.017 8.017 0 000 16.034h26.188v17.637c0 9.136 7.432 16.568 16.568 16.568h43.304c-.002.178-.014.355-.014.534 0 27.996 22.777 50.772 50.772 50.772s50.772-22.776 50.772-50.772c0-.18-.012-.356-.014-.534h180.67c-.002.178-.014.355-.014.534 0 27.996 22.777 50.772 50.772 50.772 27.995 0 50.772-22.776 50.772-50.772 0-.18-.012-.356-.014-.534h26.203a8.017 8.017 0 008.017-8.017v-85.512c.001-21.111-15.576-38.653-35.841-41.738zm-100.976-52.858h71.235l13.094 52.376h-84.329v-52.376zm60.392-34.204c9.725 0 17.637 7.912 17.637 17.637v.534h-78.029v-18.171h60.392zM144.835 401.904c-19.155 0-34.739-15.583-34.739-34.739s15.584-34.739 34.739-34.739c19.155 0 34.739 15.583 34.739 34.739s-15.584 34.739-34.739 34.739zm282.188 0c-19.155 0-34.739-15.583-34.739-34.739s15.584-34.739 34.739-34.739c19.155 0 34.739 15.583 34.739 34.739s-15.584 34.739-34.739 34.739zm59.858-102.614c-5.01 0-9.086-4.076-9.086-9.086v-9.086h18.171v18.171h-9.085z"
        data-original="#000000"
      ></path>
      <path
        d="M144.835 350.597c-9.136 0-16.568 7.432-16.568 16.568 0 9.136 7.432 16.568 16.568 16.568 9.136 0 16.568-7.432 16.568-16.568 0-9.136-7.432-16.568-16.568-16.568zm282.188 0c-9.136 0-16.568 7.432-16.568 16.568 0 9.136 7.432 16.568 16.568 16.568s16.568-7.432 16.568-16.568c0-9.136-7.432-16.568-16.568-16.568zm-221.795-26.188a8.017 8.017 0 008.017 8.017H332.96a8.017 8.017 0 000-16.034H213.244a8.017 8.017 0 00-8.016 8.017zM25.119 298.221h102.614a8.017 8.017 0 000-16.034H25.119a8.017 8.017 0 000 16.034zm242.315-124.85l-71.292 71.291-37.087-37.087a8.016 8.016 0 00-11.337 0 8.016 8.016 0 000 11.337l42.756 42.756c1.565 1.566 3.617 2.348 5.668 2.348s4.103-.782 5.668-2.348l76.96-76.96a8.016 8.016 0 10-11.336-11.337z"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default Shipped;
